import { Link } from "@tanstack/react-router";
import { dashboardNavItems } from "./shared";

interface DashboardHeaderNavProps {
	pathname: string;
}

export function DashboardHeaderNav({ pathname }: DashboardHeaderNavProps) {
	const lastSegment = pathname.split("/").filter(Boolean).pop();
	const validSegments = dashboardNavItems.map((item) => item.segment);
	const activeSegment = validSegments.includes(
		lastSegment as (typeof validSegments)[number],
	)
		? lastSegment
		: null;

	return (
		<nav aria-label="Dashboard header navigation" className="hidden lg:flex items-center gap-0.5">
			{dashboardNavItems.map((item) => {
				const isActive = activeSegment === item.segment;

				return (
					<Link
						key={item.segment}
						to={item.to}
						aria-current={isActive ? "page" : undefined}
					className="flex items-center px-2.5 py-1.5 text-sm font-bold transition-all duration-200"
						style={{
							color: isActive ? "#6B3FF2" : "#adaaaa",
							backgroundColor: isActive ? "rgba(234,40,4,0.08)" : "transparent",
							borderBottom: isActive ? "2px solid #6B3FF2" : "2px solid transparent",
						}}
						onMouseEnter={e => {
							if (!isActive) {
								(e.currentTarget as HTMLElement).style.color = "#ffffff";
								(e.currentTarget as HTMLElement).style.backgroundColor = "#201f1f";
							}
						}}
						onMouseLeave={e => {
							if (!isActive) {
								(e.currentTarget as HTMLElement).style.color = "#adaaaa";
								(e.currentTarget as HTMLElement).style.backgroundColor = "transparent";
							}
						}}
						onFocus={e => {
							if (!isActive) {
								(e.currentTarget as HTMLElement).style.color = "#ffffff";
								(e.currentTarget as HTMLElement).style.backgroundColor = "#201f1f";
							}
						}}
						onBlur={e => {
							if (!isActive) {
								(e.currentTarget as HTMLElement).style.color = "#adaaaa";
								(e.currentTarget as HTMLElement).style.backgroundColor = "transparent";
							}
						}}
					>
						{item.label}
					</Link>
				);
			})}
		</nav>
	);
}
